import {
  ApartmentOutlined,
  AppstoreOutlined,
  BookOutlined,
  BulbOutlined,
  HomeOutlined,
  LineChartOutlined,
  LogoutOutlined,
  MessageOutlined,
  PhoneOutlined,
  ProfileOutlined,
  ReadOutlined,
  ScheduleOutlined,
  SmileOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Layout, Menu } from "antd";
import { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { logout } from "../actions/auth";
import { rolePerms, userPermissions } from "../utils";
const { Content, Sider, Footer } = Layout;

const AdminLayout = (props) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };
  const items = [
    {
      label: <Link to={"/dashboard"}>Dashboard</Link>,
      key: "dashboard",
      icon: <HomeOutlined />,
    },
    rolePerms("marketing manager") && {
      label: "Platform Content",
      key: "platform-content",
      icon: <AppstoreOutlined />,
      children: [
        {
          label: <Link to={"/cards"}>Cards</Link>,
          key: "cards",
          item: <BookOutlined />,
        },
        {
          label: <Link to={"/steps"}>Steps</Link>,
          key: "steps",
          item: <ReadOutlined />,
        },
      ],
    },
    rolePerms("marketing manager") && {
      label: "Comms",
      key: "comms",
      icon: <AppstoreOutlined />,
      children: [
        {
          label: <Link to={"/blog"}>Blog</Link>,
          key: "blog",
          item: <SmileOutlined />,
        },
        {
          label: <Link to={"/stories"}>View User Stories</Link>,
          key: "stories",
          item: <BookOutlined />,
        },
        {
          label: <Link to={"/create-stories"}>Create New Stories</Link>,
          key: "create-stories",
          item: <BookOutlined />,
        },
        {
          label: <Link to={"/stories/templates"}>View Story Templates</Link>,
          key: "view-stories",
          item: <BookOutlined />,
        },
      ],
    },
    userPermissions("view users") ||
    userPermissions("edit users") ||
    userPermissions("view related users") ||
    userPermissions("edit related users")
      ? {
          label: <Link to={"/users"}>Members</Link>,
          key: "members",
          icon: <UserOutlined />,
        }
      : null,
    rolePerms("roles & permissions admin") && {
      label: <Link to={"/roles"}>Roles & Permissions</Link>,
      key: "permissions",
      icon: <ApartmentOutlined />,
    },
    userPermissions("view companies") && {
      label: <Link to={"/companies"}>Companies</Link>,
      key: "companies",
      icon: <TeamOutlined />,
    },
    userPermissions("view coaching requests") && {
      label: <Link to={"/active-coaching-list/search"}>Coaching List</Link>,
      key: "coaching-lists",
      icon: <ProfileOutlined />,
    },
    userPermissions("view coaching requests") && {
      label: <Link to={"/coaching-requests"}>Coaching Requests</Link>,
      key: "coaching-requests",
      icon: <UsergroupAddOutlined />,
    },
    userPermissions("view coaching calls") && {
      label: (
        <Link to={"/coaching-actions?filter1=true&filter2=true"}>
          Coaching Calls
        </Link>
      ),
      key: "coaching-actions",
      icon: <PhoneOutlined />,
    },
    userPermissions("edit users") && {
      label: <Link to={"/sms-message-centre"}>SMS Message Centre</Link>,
      key: "sms-message-centre",
      icon: <MessageOutlined />,
    },
    userPermissions("edit users") && !rolePerms("contract coach")
      ? {
          label: <Link to={"/coaching-themes"}>Coaching Themes</Link>,
          key: "coaching-themes",
          icon: <BulbOutlined />,
        }
      : null,
    userPermissions("view reports") && {
      label: <Link to={"/report"}>Reports</Link>,
      key: "report",
      icon: <LineChartOutlined />,
    },
    rolePerms("super admin") && {
      label: <Link to={"/audits"}>Audits</Link>,
      key: "audits",
      icon: <ScheduleOutlined />,
    },
    {
      label: (
        <Link to={"/login"} onClick={props.logout}>
          Logout
        </Link>
      ),
      key: "logout",
      icon: <LogoutOutlined />,
    },
  ];

  return (
    <Layout>
      <Sider collapsible collapsed={collapsed} onCollapse={toggleCollapsed}>
        <Menu
          defaultSelectedKeys={["1"]}
          mode="inline"
          theme="dark"
          items={items}
        />
      </Sider>
      <Layout style={{ minHeight: "100vh" }}>
        <Content style={{ margin: "24px 16px 0" }}>
          <div style={{ padding: 24, background: "#fff", minHeight: "80vh" }}>
            {props.children}
          </div>
        </Content>
        <Footer>Grace Papers</Footer>
      </Layout>
    </Layout>
  );
};

export default connect(undefined, (dispatch) => {
  return {
    logout: () => dispatch(logout()),
  };
})(AdminLayout);
